export class AuthReturn {
  client_id!: number;
  token_type!: string;
  access_token!: string;
  expires_in!: number;
  scope!: string[];
}
